// SearchBar.js
import React, { useState } from 'react';
import './SearchBar.css'; // We'll create this file next

function SearchBar({ setSearchTerm }) {
  const [inputValue, setInputValue] = useState('');
  
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSearchTerm(value);
  };
  
  const handleClearSearch = () => {
    setInputValue('');
    setSearchTerm('');
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder="Search topics..."
        value={inputValue}
        onChange={handleSearchChange}
      />
      {inputValue && (
        <button 
          className="clear-search" 
          onClick={handleClearSearch}
          aria-label="Clear search"
        >
          ×
        </button>
      )}
    </div>
  );
}

export default SearchBar;